import { createSlice } from "@reduxjs/toolkit";

// interface ControlPageProps {
//   offset?: number;
//   limit?: number;
//   sort?: string;
//   isEndData?: boolean;
// }

interface InitialState {
  searchContent: string;
}

const initialState: InitialState = {
  searchContent: "",
};

const filterListResearchReportSlice = createSlice({
  name: "filterListResearchReport",
  initialState,
  reducers: {
    updateFilterResearchReport: (state, action) => {
      state.searchContent = action.payload;
    },
    resetFilterResearchReport: () => {
      return { ...initialState };
    },
  },
});

export const { updateFilterResearchReport, resetFilterResearchReport } =
  filterListResearchReportSlice.actions;

export default filterListResearchReportSlice.reducer;
